import Button from 'components/Button';
import Error from 'components/form/Error';
import Space from 'components/Space';
import styled from 'styled-components';
import Columns from './Columns';
import Head from './Head';

const ButtonContainer = styled.div`
  width: 100%;
  max-width: 70rem;
  align-self: center;
  display: flex;
  align-items: center;
  justify-content: flex-end;
`;

// type Tag = {
//   name: string;
//   label: string;
//   labelComponent?: React.ReactElement | string;
// };
// type TagColumn<T extends string> = {
//   columnName: T;
//   columnTitle: string;
//   tags: Tag[];
// };
type Props<
  // T extends string,
  U extends string,
> = {
  backTo: string;
  pageTitle: string;
  // tagList: TagColumn<T>[] | null;
  // tags: Record<T, string[]>;
  // setTags: (tags: Record<T, string[]>) => void;
  columnList: readonly U[];
  columns: Record<U, boolean>;
  setColumns: (columns: Record<U, boolean>) => void;
  onDowload: () => void;
  loading: boolean;
  error: string;
};
function ExportsPage<
  // T extends string,
  U extends string,
>({
  backTo,
  pageTitle,
  // tagList,
  // tags,
  // setTags,
  columnList,
  columns,
  setColumns,
  onDowload,
  loading,
  error,
}: Props<U>) {
  return (
    <>
      <Head {...{ backTo, title: pageTitle }} />
      {/* <Filters {...{ tagList, tags, setTags }} />
      <Space height={2} /> */}
      {error && (
        <>
          <Error
            style={{ width: '100%', maxWidth: '70rem', alignSelf: 'center' }}
          >
            {error}
          </Error>
          <Space height={0.5} />
        </>
      )}
      <Columns {...{ columnList, columns, setColumns }} />
      <Space height={1} />
      <ButtonContainer>
        <Button
          type="button"
          color="primary"
          onClick={onDowload}
          loading={loading}
        >
          Exporter
        </Button>
      </ButtonContainer>
    </>
  );
}

export default ExportsPage;
